export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-ink text-ivory py-2.5 text-center"
    >
      <p className="eyebrow text-ivory" style={{ letterSpacing: "0.28em", fontSize: 11 }}>
        Whisper — The First Note. Underbloom, arriving 2027.
      </p>
    </div>
  );
}
